<template>
  <div class="min-h-screen bg-black text-white">
    

    <!-- 主要内容 -->
    <main class="max-w-lg mx-auto px-4 py-12">
      <h1 class="text-6xl font-bold text-center mb-16">一对一私人咨询</h1>
      
      <p class="text-center mb-12">填写以下资料，为你量身定製的财富增值蓝图。</p>

      <form @submit.prevent="handleSubmit" class="space-y-8">
        <!-- 称呼 -->
        <div>
          <label class="block mb-2">如何称呼你 <span class="text-yellow-500">*</span></label>
          <input 
            v-model="formData.name"
            type="text"
            class="w-full bg-transparent border border-gray-600 rounded-md px-4 py-2 focus:border-yellow-500 focus:ring-1 focus:ring-yellow-500"
            :class="{'border-yellow-500': errors.name}"
          >
          <p v-if="errors.name" class="mt-1 text-yellow-500 text-sm">{{ errors.name }}</p>
        </div>

        <!-- 资产类型 -->
        <div>
          <label class="block mb-2">你的主要资产类别 <span class="text-yellow-500">*</span></label>
          <div class="grid grid-cols-2 gap-4">
            <label v-for="asset in assets" :key="asset" class="flex items-center space-x-2">
              <input 
                type="checkbox"
                v-model="formData.selectedAssets"
                :value="asset"
                class="rounded border-gray-600 text-yellow-500 focus:ring-yellow-500"
              >
              <span>{{ asset }}</span>
            </label>
          </div>
          <p v-if="errors.selectedAssets" class="mt-1 text-yellow-500 text-sm">{{ errors.selectedAssets }}</p>
        </div>

        <!-- 投资经验 -->
        <div>
          <label class="block mb-2">金融市场从业经验</label>
          <select 
            v-model="formData.tradingExperience"
            class="w-full bg-transparent border border-gray-600 rounded-md px-4 py-2 focus:border-yellow-500 focus:ring-1 focus:ring-yellow-500"
          >
            <option value="0-1">1年以内</option>
            <option value="1-3">1-3年</option>
            <option value="3-5">3-5年</option>
            <option value="5+">5年以上</option>
          </select>
        </div>

        <!-- 流动性资金比重 -->
        <div>
          <label class="block mb-2">流動性資金（Cash）佔資產比重</label>
          <select 
            v-model="formData.liquidityRatio"
            class="w-full bg-transparent border border-gray-600 rounded-md px-4 py-2 focus:border-yellow-500 focus:ring-1 focus:ring-yellow-500"
          >
            <option value="5-15">5%～15%</option>
            <option value="15-30">15%～30%</option>
            <option value="30-50">30%～50%</option>
            <option value="50-70">50%～70%</option>
            <option value="70+">70%以上</option>
          </select>
        </div>

        <!-- 投资收益 -->
        <div>
          <label class="block mb-2">在今年（公元2024年）你的投资收益为</label>
          <select 
            v-model="formData.investmentReturn"
            class="w-full bg-transparent border border-gray-600 rounded-md px-4 py-2 focus:border-yellow-500 focus:ring-1 focus:ring-yellow-500"
          >
          <option value="lossing">目前虧損</option>
          <option value="5-15">5%～15%</option>
            <option value="15-30">15%～30%</option>
            <option value="30-50">30%～50%</option>
            <option value="50+">50%以上</option>
            
          </select>
        </div>

        <!-- 期望 -->
        <div>
          <label class="block mb-2">哪個最符合你的期望 <span class="text-yellow-500">*</span></label>
          <select 
            v-model="formData.expectation"
            class="w-full bg-transparent border border-gray-600 rounded-md px-4 py-2 focus:border-yellow-500 focus:ring-1 focus:ring-yellow-500"
            :class="{'border-yellow-500': errors.expectation}"
          >
            <option value="1">期望達到財富大幅增值，同時願意承擔資產大幅波動風險</option>
            <option value="2">期望達到財富穩健增長，可接受適度風險</option>
            <option value="3">期望跑贏通膨，風險承受度較低</option>
            <option value="4">期望實現全球資產配置，分散投資風險</option>
          </select>
          <p v-if="errors.expectation" class="mt-1 text-yellow-500 text-sm">{{ errors.expectation }}</p>
        </div>

        <!-- 联系方式 -->
        <div>
          <label class="block mb-2">你的联络方式（电邮地址）<span class="text-yellow-500">*</span></label>
          <input 
            v-model="formData.contact"
            type="email"
            class="w-full bg-transparent border border-gray-600 rounded-md px-4 py-2 focus:border-yellow-500 focus:ring-1 focus:ring-yellow-500"
            :class="{'border-yellow-500': errors.contact}"
          >
          <p v-if="errors.contact" class="mt-1 text-yellow-500 text-sm">{{ errors.contact }}</p>
        </div>

        <!-- 补充联络方式 -->
        <div>
          <label class="block mb-2">补充联络方式（可选）</label>
          <input 
            v-model="formData.altContact"
            type="text"
            class="w-full bg-transparent border border-gray-600 rounded-md px-4 py-2 focus:border-yellow-500 focus:ring-1 focus:ring-yellow-500"
            placeholder="Telegram/Discord/WhatsApp/etc..."
          >
        </div>

        <!-- 补充信息 -->
        <div>
          <label class="block mb-2">你目前遇到的最大问题是什么（可选）</label>
          <textarea 
            v-model="formData.additionalInfo"
            rows="4"
            class="w-full bg-transparent border border-gray-600 rounded-md px-4 py-2 focus:border-yellow-500 focus:ring-1 focus:ring-yellow-500"
            placeholder="例如：如何选择合适的投资产品、如何管理风险、如何优化投资组合等"
          ></textarea>
        </div>

        

        

        <!-- 添加消息显示区域 -->
        <div v-if="errorMsg" class="text-yellow-500 text-sm text-center">
          {{ errorMsg }}
        </div>
        
        <div v-if="successMsg" class="text-yellow-500 text-sm text-center">
          {{ successMsg }}
        </div>

        <button 
          type="submit"
          class="w-full bg-yellow-500 text-black font-bold py-2 px-4 rounded-lg hover:bg-yellow-400 transition-colors disabled:opacity-50"
          :disabled="isSubmitting"
        >
          {{ isSubmitting ? '提交中...' : '立即提交' }}
        </button>
      </form>
    </main>

    <SuccessModal 
      :show="showSuccessModal"
      @close="showSuccessModal = false"
    />
  </div>
</template>

<script setup lang="ts">
import { reactive, ref, computed, watch } from 'vue'
import axios from 'axios'
import SuccessModal from '@/components/SuccessModal.vue'

const assets = [
  '房产',
  '股票',
  '债券',
  '主动管理基金',
  '被动 ETFs',
  '加密货币',
  '公司股权',
  '金融衍生品'
]

const assetMapping = {
  '房产': 'real_estate',
  '股票': 'stocks',
  '债券': 'bonds',
  '主动管理基金': 'active_funds',
  '被动 ETFs': 'passive_etfs',
  '加密货币': 'crypto',
  '公司股权': 'equity', 
  '金融衍生品': 'derivatives'
}

interface FormErrors {
  name?: string
  selectedAssets?: string
  liquidityRatio?: string
  investmentReturn?: string
  expectation?: string
  contact?: string
}

const formData = reactive({
  name: '',
  selectedAssets: [] as string[],
  liquidityRatio: '5-15',
  investmentReturn: '5-15',
  expectation: '',
  contact: '',
  additionalInfo: '',
  tradingExperience: '0-1',
  altContact: '',
})

const errors = reactive<FormErrors>({})
const isSubmitting = ref(false)

const enableValidation = ref(false)

// 修改 watch 来根据 enableValidation 控制验证
watch(
  () => formData,
  () => {
    if (enableValidation.value) {
      validateForm()
    }
  },
  { deep: true }
)

const validateEmail = (email: string): boolean => {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return re.test(email.trim())
}

const validateForm = (): boolean => {
  errors.name = ''
  errors.selectedAssets = ''
  errors.expectation = ''
  errors.contact = ''
  let isValid = true

  // 验证称呼
  if (!formData.name.trim()) {
    errors.name = '请输入你的称呼'
    isValid = false
  }

  // 验证资产类型
  if (formData.selectedAssets.length === 0) {
    errors.selectedAssets = '请至少选择一项资产类别'
    isValid = false
  }

  // 验证期望
  if (!formData.expectation) {
    errors.expectation = '请选择你的投资期望'
    isValid = false
  }

  // 验证联系方式
  if (!formData.contact) {
    errors.contact = '请输入你的电邮地址'
    isValid = false
  } else if (!validateEmail(formData.contact)) {
    errors.contact = '请输入有效的电邮地址'
    isValid = false
  }

  return isValid
}

// 添加消息状态
const errorMsg = ref('')
const successMsg = ref('')

// 添加 showSuccessModal ref
const showSuccessModal = ref(false)

const handleSubmit = async () => {
  enableValidation.value = true // 激活表单验证
  if (!validateForm()) {
    return
  }

  isSubmitting.value = true
  errorMsg.value = ''
  successMsg.value = ''
  
  try {
    const response = await axios.post('/api/register/vip', {
      email: formData.contact.trim(),
      name: formData.name,
      assets: formData.selectedAssets.map(asset => assetMapping[asset as keyof typeof assetMapping]),
      expectation: formData.expectation,
      liquidityRatio: formData.liquidityRatio,
      investmentReturn: formData.investmentReturn,
      additionalInfo: formData.additionalInfo,
      tradingExperience: formData.tradingExperience,
      altContact: formData.altContact,
    })
    if (response.status === 200) {
      showSuccessModal.value = true // 显示成功模态框
      enableValidation.value = false
      successMsg.value = '提交成功！我们会尽快与你联系'
      // 重置表单
      formData.name = ''
      formData.selectedAssets = []
      formData.liquidityRatio = '5-15'
      formData.investmentReturn = '5-15'
      formData.expectation = ''
      formData.contact = ''
      formData.additionalInfo = ''
      formData.altContact = ''
    } else if (response.status === 201) {
      successMsg.value = '你已经提交过申请，我们会尽快与你联系'
    }
  } catch (error) {
    errorMsg.value = '提交失败，请稍后重试'
  } finally {
    isSubmitting.value = false
  }
}
</script>

<style scoped>
/* 可以添加自定义样式 */
</style>